import {initMixpanel} from 'common/report/tracking-setup';

export enum DigestTrackingEvent {
  // Digest
  ChangedFrequency = `Changed frequency`,
  ChangedTimezone = `Changed timezone`,
  CloseEditDigestBuilder = `Closed edit digest builder`,
  CloseNewDigestBuilder = `Closed new digest builder`,
  DeleteDigest = `Deleted digest`,
  DuplicateDigest = `Duplicated digest`,
  EditDigest = `Edited digest`,
  OpenNewDigestBuilder = `Opened new digest builder`,
  SaveNewDigest = `Saved new digest`,
  ToggleDigestSending = `Toggled digest sending`,
  ViewedDigestControlCenter = `Viewed digest control center`,

  // Subscriptions (new digests)
  ExportBoardModalOpened = `[Subscription] Export board modal opened`,
  ExportBoardModalSubmitted = `[Subscription] Export board modal submitted`,
  SendTestSubscriptionButton = `[Subscription] Send test subscription button clicked`,
  SubscriptionInlineSubUnsubButton = `[Subscription] Sub/unsub button clicked`,
  OpenSubscribeButtonMenu = `[Subscription] Open subscribe button menu`,
}

export enum SaveNewDigestUiLocation {
  SubscriptionsPage = `subscriptions page`,
  SubscribeButtonMenu = `subscribe button menu`,
}

let mixpanel;

export function track(event: DigestTrackingEvent, data: Record<string, any> = {}) {
  // Don't initialize mixpanel immediately on import so we don't break tests
  if (!mixpanel) {
    mixpanel = initMixpanel(PROJECT_3_MIXPANEL_TOKEN);
  }
  mixpanel.track(event, data);
}
